const images = {
  login: require('../Assets/images/login.png'),
  logo: require('../Assets/images/logo.png'),
  lock: require('../Assets/images/lock.png'),
  logo_white: require('../Assets/images/logo_white.png'),
  admin: require('../Assets/images/admin.png'),
  instructor: require('../Assets/images/instructor.png'),
  user: require('../Assets/images/user.png'),
  username: require('../Assets/images/username.png'),
  mail: require('../Assets/images/mail.png'),
  call: require('../Assets/images/call.png'),
  eye_off: require('../Assets/images/eye-off.png'),
  calendar: require('../Assets/images/calendar.png'),
  student: require('../Assets/images/student.png'),
  verify_mail: require('../Assets/images/verify_mail.png'),
  logoPlaceholder: require('../Assets/images/logoPlaceholder.png'),
  wrongImg: require('../Assets/images/wrongImg.png'),
  right: require('../Assets/images/right.png'),
  logout: require('../Assets/images/logout.png'),
  plus: require('../Assets/images/plus.png'),
  profile: require('../Assets/images/profile.png'),
  card: require('../Assets/images/card.png'),
  chatIcon: require('../Assets/images/chatIcon.png'),

  // ==================== Sidebar ========================
  medal: require('../Assets/images/medal.png'),
  dots: require('../Assets/images/dots.png'),
  dashboard: require('../Assets/images/dashboard.png'),
  dashboard1: require('../Assets/images/dashboard1.png'),
  resources: require('../Assets/images/resources.png'),
  resources1: require('../Assets/images/resources1.png'),
  students: require('../Assets/images/students.png'),
  students1: require('../Assets/images/students1.png'),
  courses: require('../Assets/images/courses.png'),
  courses1: require('../Assets/images/courses1.png'),
  schedule: require('../Assets/images/schedule.png'),
  schedule1: require('../Assets/images/schedule1.png'),
  introduction: require('../Assets/images/introduction.png'),
  add: require('../Assets/images/add.png'),

  // ==================== TopBar ========================
  chat: require('../Assets/images/chat.png'),
  notification: require('../Assets/images/notification.png'),
  setting: require('../Assets/images/setting.png'),
  search: require('../Assets/images/search.png'),
  hamburger: require('../Assets/images/hamburger.png'),
  dotsWhite: require('../Assets/images/dotsWhite.png'),
  editProfile: require('../Assets/images/editProfile.png'),

  // ==================== Folder Structure ========================
  doc: require('../Assets/images/doc.png'),
  doc1: require('../Assets/images/doc1.png'),
  
  // ==================== Dashboard ========================
  lineChart: require('../Assets/images/lineChart.png'),
  lineChart2: require('../Assets/images/lineChart2.png'),
  barChart: require('../Assets/images/barChart.png'),
  myCourses: require('../Assets/images/myCourses.png'),

  // ==================== Courses ========================
  course: require('../Assets/images/course.png'),
  design: require('../Assets/images/design.png'),
  programming: require('../Assets/images/programming.png'),
  softSkill: require('../Assets/images/softSkill.png'),
  microscope: require('../Assets/images/microscope.png'),
  star: require('../Assets/images/star.png'),
  // ==================== Students ========================
  dots1: require('../Assets/images/dots1.png'),
  upDown: require('../Assets/images/upDown.png'),
  
  // ==================== Resources ========================
  upBorder: require('../Assets/images/upBorder.png'),
  callWhite: require('../Assets/images/callWhite.png'),
  addressWhite: require('../Assets/images/addressWhite.png'),
  mailWhite: require('../Assets/images/mailWhite.png'),
  quiz: require('../Assets/images/quiz.jpg'),
  
};

export default images;
